import { DownOutlined, RightOutlined } from '@ant-design/icons'
import React from 'react'
import styled from 'styled-components'
import type { NoyoDifference } from 'enrollment-platform/api/partner-benefit-graph/noyo-differences.types'

const ExpandButton = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 0;
  border: none;
  background: transparent;
  cursor: pointer;
  color: inherit;
`

type NoyoIssueExpandIconProps = {
  expanded: boolean
  expandable: boolean
  record: NoyoDifference
  onExpand: (
    record: NoyoDifference,
    event: React.MouseEvent<HTMLElement>
  ) => void
}

export function NoyoIssueExpandIcon({
  expanded,
  expandable,
  record,
  onExpand,
}: NoyoIssueExpandIconProps) {
  if (!expandable) {
    return null
  }

  return (
    <ExpandButton
      type="button"
      aria-label={expanded ? 'Collapse row' : 'Expand row'}
      aria-expanded={expanded}
      onClick={(event) => onExpand(record, event)}
    >
      {expanded ? (
        <DownOutlined aria-hidden="true" />
      ) : (
        <RightOutlined aria-hidden="true" />
      )}
    </ExpandButton>
  )
}
